import { Trans } from '@lingui/macro'
import { Button } from '@mui/material'

export function ShowMoreButton({ hasNextPage, setNextPage }: { hasNextPage: boolean; setNextPage: () => void }) {
  if (!hasNextPage) return null

  return (
    <Button variant="outlined" onClick={setNextPage}>
      <Trans>Show more</Trans>
    </Button>
  )
}
